import { SurveyListOption } from '@hyper-inferno/survey-elements-core';

export async function getRandomizedOptions(
  options: SurveyListOption[],
) {
  // 1. Identify which items should stay put
  // These are the "fixed" indices and their values
  const fixedIndices = new Set<number>();
  options.forEach((opt, index) => {
    if (opt.is_mutually_exclusive || opt.is_open_ended) {
      fixedIndices.add(index);
    }
  });

  // 2. Extract only the items that ARE allowed to be randomized
  const toRandomize = options.filter(
    (opt) => !opt.is_mutually_exclusive && !opt.is_open_ended,
  );

  // 3. Fisher-Yates Shuffle for the randomizable items
  for (let i = toRandomize.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [toRandomize[i], toRandomize[j]] = [toRandomize[j], toRandomize[i]];
  }

  // 4. Reconstruct the final array
  let randomArrayIndex = 0;
  const result = options.map((originalOpt, index) => {
    // If this position was fixed, return the original item
    if (fixedIndices.has(index)) {
      return originalOpt;
    }
    // Otherwise, pull the next item from our shuffled pool
    return toRandomize[randomArrayIndex++];
  });

  return result;
}
